export default __webpack_public_path__ + "static/media/donut-honeyswap.9b71564f.png";